/* DI MARTINO MAISON · módulos de conversión */

/* ---- Módulos de conversión ---- */
(function () {
  /* Cuenta regresiva del drop */
  function clock(el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) { el.classList.add('is-over'); return; }
    var f = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var t = end - Date.now();
      if (t <= 0) { el.classList.add('is-over'); clearInterval(el.__t); return; }
      var d = Math.floor(t / 864e5), h = Math.floor(t % 864e5 / 36e5), m = Math.floor(t % 36e5 / 6e4), s = Math.floor(t % 6e4 / 1e3);
      if (f.d) f.d.textContent = pad(d); if (f.h) f.h.textContent = pad(h);
      if (f.m) f.m.textContent = pad(m); if (f.s) f.s.textContent = pad(s);
    }
    tick(); el.__t = setInterval(tick, 1000);
  }

  /* Reels: autoplay silencioso, tap para sonido */
  function reel(el) {
    var v = el.querySelector('video'); if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.35 }) : null;
    if (io) io.observe(el); else v.play();
    el.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      document.querySelectorAll('.m-reel video').forEach(function (o) { if (o !== v) { o.muted = true; o.closest('.m-reel').classList.remove('is-on'); } });
      v.muted = !v.muted; el.classList.toggle('is-on', !v.muted);
      var b = el.querySelector('.m-reel__sound'); if (b) b.textContent = v.muted ? '♪' : '❙❙';
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  /* Filtros por etiqueta */
  function filters(sec) {
    var chips = sec.querySelectorAll('.m-chip'); if (!chips.length) return;
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (o) { o.classList.remove('is-on'); });
        c.classList.add('is-on');
        var f = (c.getAttribute('data-filter') || '').toLowerCase();
        sec.querySelectorAll('.m-card').forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          card.classList.toggle('is-hidden', f !== '' && tags.indexOf(f) === -1);
        });
      });
    });
  }

  function boot(root) {
    root = root || document;
    root.querySelectorAll('[data-end]').forEach(clock);
    root.querySelectorAll('.m-reel').forEach(reel);
    root.querySelectorAll('[data-m-filters]').forEach(filters);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
